/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _EditCommentFormContainer_settings$ref: unique symbol;
export type EditCommentFormContainer_settings$ref = typeof _EditCommentFormContainer_settings$ref;
export type EditCommentFormContainer_settings = {
    readonly charCount: {
        readonly enabled: boolean;
        readonly min: number | null;
        readonly max: number | null;
    };
    readonly " $refType": EditCommentFormContainer_settings$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "EditCommentFormContainer_settings",
    "type": "Settings",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "charCount",
            "storageKey": null,
            "args": null,
            "concreteType": "CharCount",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "enabled",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "min",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "max",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '451789d41a13598aea34ed0977b48de5';
export default node;
